
import { Button } from '@material-ui/core';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import React, { Component, useEffect, useRef, useState } from 'react';

function Product({ product }) {
    const [paidFor, setPaidFor] = useState(false);
    const [error, setError] = useState(null);
    const paypalRef = useRef();

    let sendEmail = (order) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "email": order.payer.email_address,
                "givenName": order.payer.name.given_name,
                "SurName": order.payer.name.surname,
                "TransactionId": order.purchase_units[0].payments.captures[0].id,
                "amount": order.purchase_units[0].description,
                "Create_Time": order.create_time
            })
        }

        fetch('/api/email', requestOptions)
            .then(response => response.json())
            .then(data => console.log(data));
    }

    useEffect(() => {
        window.paypal
            .Buttons({
                createOrder: (data, actions) => {
                    return actions.order.create({
                        purchase_units: [
                            {
                                description: product.description,
                                amount: {
                                    currency_code: 'USD',
                                    value: product.price,
                                },
                            },
                        ]
                    });
                },
                onApprove: async (data, actions) => {
                    const order = await actions.order.capture();
                    setPaidFor(true);
                    console.log("actions", actions)
                    console.log("Order", order);
                    console.log("Data", data);
                    try {
                        sendEmail(order)
                    } catch (e) {
                        console.log(e);
                    }
                },
                onError: err => {
                    setError(err);
                    console.error(err);
                },
            })
            .render(paypalRef.current);
    }, [product.description, product.price]);

    if (paidFor) {
        return (
            <div>
                <h1>Thank you for your donation of ${product.price}.</h1>
            </div>
        );
    }

    return (
        <div>
            {error && <div>Uh oh, an error occurred! {error.message}</div>}
            <h2>
                A donation of {product.description}
            </h2>
            <div ref={paypalRef} />
        </div>
    );
}

class Donations extends Component {

    state = {
        product: null,
        processPayment: true,
        chooseAmount: false,
        validAmount: false
    }
    products = [
        {
            price: 50.00,
            name: '$50.00 USD',
            description: '$50.00 USD Professional Development and Scholarship Donation'
        },
        {
            price: 500.00,
            name: '$500.00 USD',
            description: '$500.00 USD Professional Development and Scholarship Donation'
        },
        {
            price: 100.00,
            name: '$100.00 USD',
            description: '$100.00 USD Professional Development and Scholarship Donation'
        },
        {
            price: 1000.00,
            name: '$1000.00 USD',
            description: '$1000.00 USD Professional Development and Scholarship Donation'
        },
        {
            price: 250.00,
            name: '$250.00 USD',
            description: '$250.00 USD Professional Development and Scholarship Donation'
        }
    ];

    close_window = () => {
        window.close();
    }

    checkout(product) {
        this.setState({
            product: product,
            processPayment: true
        })
    }

    ChooseDonation() {
        this.setState({
            chooseAmount: true
        })
    }

    handleTextFieldChange(e) {
        // adding a "+" to the event target value is type coersion of a string to a number
        let amount = +e.target.value.replace(',', '');
        amount = amount.toFixed(2)
        let product = {
            price: amount,
            name: `$${amount} USD`,
            description: `$${amount} USD Professional Development and Scholarship Donation`
        }

        this.setState({
            product: product,
            validAmount: this.validate(amount)
        })
    }
    AmountChoosen() {
        this.setState({
            chooseAmount: false,
            processPayment: true
        })

    }

    navigateBack() {
        this.setState({
            processPayment: false,
            validAmount: false,
            chooseAmount: false
        })
    }

    validate(amount) {
        if (amount < 50) {
            return false;
        }
        if (amount > 10000) {
            return false;
        }
        return true;
    }

    isNotValid() {
        return !this.state.validAmount;
    }

    productList = this.products.map(product => {
        return (
            <div key={product.name} className="col-6">
                {<Button size="large" variant="outlined" color="secondary" className="col-12 m-2" key={product.name} onClick={() => this.checkout(product)}> {product.name} </Button>}
            </div>
        )
    })

    render() {

        if (this.state.processPayment && this.state.product && !this.state.chooseAmount) {
            return (
                <div className="text-center">
                    <Button size="large" className="m-1" variant="outlined" color="secondary" onClick={() => { this.navigateBack() }}>Back</Button>
                    <Product product={this.state.product} />
                </div>
            );
        } if (this.state.chooseAmount) {
            return (
                <div className="Container">
                    <div className="col-13">
                        <p>No Goods or Services were provided or promised in return for your support, this is not a quid pro quo benefit provided to you. </p>
                    </div>
                    <div className="row">
                        <div className="col-3">
                    </div>
                        <div className="col-9">
                            <p>Please enter your donation amount below:</p>
                                <form noValidate autoComplete="off">
                                    <p>The minimum donation amount is $50.00 USD.</p>
                                    <div className="row m-1">
                                        <Button
                                            size="large"
                                            variant="outlined"
                                            color="secondary"
                                            className="m-1"
                                            onClick={() => { this.navigateBack() }}
                                        >Back</Button>
                                    </div>
                                    <div className="row m-1">
                                        <CurrencyTextField
                                            currencySymbol="$"
                                            minimumValue="0"
                                            outputFormat="number"
                                            decimalCharacter="."
                                            digitGroupSeparator=","
                                            onChange={(e) => { this.handleTextFieldChange(e) }}
                                            autoComplete="off"
                                            id="outlined-basic"
                                            label="Amount"
                                            variant="outlined" />
                                    </div>
                                    <div className="row m-1">
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            disabled={this.isNotValid()}
                                            className="m-1"
                                            onClick={() => this.AmountChoosen()}
                                        > Confirm </Button>
                                    </div>
                                </form>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="container">
                    <div className="row">
                    <div className="col-3">
                    </div>
                    <div className= "col-6">
                        <h2 className="text-center">Donation Amounts</h2>
                        <div className="row justify-content-center">
                            {this.productList}
                            <div className="col-6">
                                <Button size="large" variant="outlined" color="secondary" className="col-12 m-2" key="ChooseDonationAmount" onClick={() => this.ChooseDonation()}> Enter Amount USD </Button>
                                </div>
                                
                            </div>
                           
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-3">
                            </div>
                            <div>
                            <p>
                                    No goods or services were provided or promised in return for your donation.
                            </p>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default Donations;